import { Table } from 'antd'
import { cryptoColumn } from '../../customers/column'

const CryptoTable = ({ data, setData, setOpen, setOpenDeleteModal, getModulePermission }) => {
  return (
    <div>
        <Table dataSource={data || []} columns={cryptoColumn(setData, setOpen, setOpenDeleteModal, getModulePermission)} pagination={false} />
    </div>
  )
}

export default CryptoTable
